module.exports = __webpack_public_path__ + "img/common-file-text.9970c0f4.svg";